import React, { useState } from "react";
import styled from "styled-components";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";

function Header() {
  const [burgerstatus, setBurgerStatus] = useState(false);
  return (
    <Container>
      <a href="/">
        <img src="logo2.png" alt="" />
      </a>

      <Menu>
        <p>
          <a href="#aa">Computer Model</a>
        </p>
        <p>
          <a href="#bb">Flower Art</a>
        </p>
        <p>
          <a href="#cc">Coffee Menu</a>
        </p>
      </Menu>
      <CustomMenuIcon onClick={() => setBurgerStatus(true)} />
      <BurgerNav show={burgerstatus}>
        <CloseWrap>
          <CustomClose onClick={() => setBurgerStatus(false)} />
        </CloseWrap>
        <li>
          <a href="#aa" onClick={() => setBurgerStatus(false)}>
            Computer Model
          </a>
        </li>
        <li>
          <a href="#bb" onClick={() => setBurgerStatus(false)}>
            Flower Art
          </a>
        </li>
        <li>
          <a href="#cc" onClick={() => setBurgerStatus(false)}>
            Coffee Menu
          </a>
        </li>
      </BurgerNav>
    </Container>
  );
}

export default Header;

const Container = styled.div`
  padding: 30px 50px;
  /* min-height: 60px; */
  width: 100%;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1;
`;

const Logo = styled.div`
  border: 1px solid blue;
`;

const Menu = styled.div`
  width: 50%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  p {
    font-weight: 400;
    text-transform: uppercase;
    margin-left: 20px;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

const CustomMenuIcon = styled(MenuIcon)`
  @media (min-width: 768px) {
    display: none !important;
  }
  cursor: pointer;
`;

const BurgerNav = styled.div`
  transform: ${(props) => (props.show ? "translateX(0%)" : "translate(100%)")};
  transition: transform 0.2s ease;
  border: 1px solid red;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: white;
  width: 300px;
  list-style: none;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: start;
  li {
    padding: 15px;
    border-bottom: 1px solid grey;
  }
  a {
    color: black;
  }
`;

const CustomClose = styled(CloseIcon)`
  cursor: pointer;
  font-size: 50px;
  background-color: black;

  * {
    color: white;
  }
`;

const CloseWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 100px;
`;
